export default __webpack_public_path__ + "static/media/ready-not-selected.ae4b928a.svg";